import React from "react"
import Login from "../components/pages/login"

const LoginPage = (props) => <Login {...props} />

export default LoginPage